import { Subject } from 'rxjs';

import { Input, Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'sn-whooster-phone-details',
  templateUrl: './whooster-phone-details.component.html',
  styleUrls: ['./whooster-phone-details.component.scss'],
})
export class FsWhoosterPhoneDetailsComponent implements OnDestroy {
  @Input() public readonly data;

  private readonly _destroy$ = new Subject<void>();

  constructor() {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public moreDetails(): boolean {
    return (
      this.data?.name?.length > 1 ||
      this.data?.phone?.length > 1 ||
      this.data?.email?.length > 1 ||
      this.data?.relatives?.length > 1
    );
  }
}
